export default __webpack_public_path__ + "static/media/pikachu-3d.edea2caa.png";